import { create } from 'zustand';

type AssistantState = {
  /** A question handed over by another screen ("Ask about this report"); the Ask page sends it once. */
  queued: string | null;
  ask: (question: string) => void;
  takeQueued: () => string | null;
};

export const useAssistantStore = create<AssistantState>()((set, get) => ({
  queued: null,
  ask: (question) => { set({ queued: question }); },
  takeQueued: () => {
    const q = get().queued;
    if (q) set({ queued: null });
    return q;
  },
}));
